import * as React from 'react';

export default class LazyImage extends React.Component<any, any> {
    private defaultSrc = "../../assets/img/no_image.jpg";
    constructor(props) {
        super(props);

        this.state = {
            loaded: false
        }

        this.onError = this.onError.bind(this);
    }

    componentDidMount() {
        this.loadImage();
    }

    loadImage() {
        if (!this.state.loaded) {
            // Load real image
            const imgLoader = new Image();
            imgLoader.src = this.props.src;

            imgLoader.onload = () => {
                this.setState({
                    loaded: true
                });
            }
        }
    }

    render() {
        return (
            this.state.loaded ? <img
                {...this.props}
                className={`${this.props.className}`}
                alt={this.props.alt}
                onError={this.props.onError || this.onError}
            /> : <div className={"lazy-image " + this.props.classPlaceHolder}></div >

        )
    }

    private onError(e) {
        e.target.src = this.defaultSrc;
    }
}